import {Palette} from '../type/palette.type';

export const defaultPalette: Palette = {
  50: '#e6edf5',
  100: '#c0d4e4',
  200: '#98bad3',
  300: '#70a0c2',
  400: '#4986b1',
  500: '#0E3049',
  600: '#0c2a3c',
  700: '#0a2330',
  800: '#081c23',
  900: '#051417'
}
